import apiClient from './apiClient';

export const fetchModules = async () => {
  const response = await apiClient.get('/modules');
  return response.data;
};